import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import WhatWeDo from "../components/WhatWeDo";
import VideoSection from "../components/VideoSection";
import Matrix from "../components/Matrix";
import HowWeDo from "../components/HowWeDo";
import MeetSandra from "../components/MeetSandra";
import Testimonials from "../components/Testimonials";
import FaqSection from "../components/FaqSection";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = "Sassy Full Stack Fitness | The Menopause Matrix";
  }, []);

  useEffect(() => {
    let id = null;
    if (location.pathname === "/matrix") id = "matrix";
    else if (location.state && location.state.scrollTo) id = location.state.scrollTo;
    else if (location.hash) id = location.hash.slice(1);
    if (id) {
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <div className="bg-background min-h-screen">
      <Header />
      <main>
        <Hero />
        <WhatWeDo />
        <VideoSection />
        <Matrix />
        <HowWeDo />
        <MeetSandra />
        <Testimonials />
        <FaqSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
